import { useLazyQuery } from "@apollo/client/react";
import { FormControl, Grid } from '@mui/material';
import React, { useMemo } from 'react';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { SelectInput } from '../../../components/selectInput/SelectInput';

export default function InputProgramas({ options = [], programas = [], handleChangeProgramas, disabled }) {

  const handleRemove = (id) => {
    handleChangeProgramas([...programas.filter((x) => x !== id)]);
  };

  const handleChange = (e) => {
    const item = e.target.value;

    handleChangeProgramas([...programas, item]);
  };

  const initialColumns = [
  {
    field: 'name',
    headerName: 'Descripcion'
  },
  {
    headerName: '',
    field: 'action',
    flex: 0.02,
    renderCell: (cellProps) => {
      const { row } = cellProps;
      return (
        <DeleteOutlineIcon
          className='edit-icon-no-margin'
          titleAccess='Eliminar'
          onClick={(e) => !disabled ? handleRemove(row.id) : null}
          sx={{ cursor: 'pointer' }} />);


    }
  }];


  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns), [programas]);

  return (
    <>
            <FormControl variant="outlined" sx={{ alignItems: 'left' }} fullWidth>
                <Grid
          container
          spacing={0}
          direction="row"
          alignItems="left"
          justifyContent="left">
                    <Grid sx={{ boxSizing: 'border-box', width: '100%', paddingBottom: '1%' }} size={{ xs: 12, md: 6, lg: 6 }}>
                        <SelectInput
              options={options.filter((option) => !programas.some((savedPrograma) => savedPrograma === option.id))}
              label='Programas'
              placeHolder='Elige un Programa'
              onChange={handleChange}
              disabled={disabled} />
            
                    </Grid>
                </Grid>
                <Grid
          container
          spacing={1}
          direction="row"
          alignItems="left"
          justifyContent="left">
                    <Grid sx={{ boxSizing: 'border-box', width: '100%', paddingTop: '2%' }} size={{ xs: 12, md: 12, lg: 12 }}>
                        <DataGridGenerico
              hideFooterPagination={true}
              pageSize={99}
              columns={columns}
              rows={
              options?.filter((option) => programas?.some((savedPrograma) => savedPrograma === option.id))
              }
              toolbar={false}
              totalCount={options?.filter((option) => programas?.some((savedPrograma) => savedPrograma === option.id)).length} />
            
                    </Grid>
                </Grid>
            </FormControl>
        </>);

}